module.exports = __webpack_public_path__ + "static/media/ethernet.4001aac7.svg";